






import Vue from 'vue';
import {Component} from 'vue-property-decorator';
//@ts-ignore
import store from "../../store";

@Component({
    components: {},
    props: {
        playerId: {
            type: String,
            required: true
        }
    }
})

export default class PlayerCards extends Vue {
    private playerId!: string;

    /**
     * Проверка, готово ли поле и есть игроки
     */
    private get isAvailable(): boolean {
        return this.fieldState !== null && this.fieldState.players !== null;
    }

    /**
     * Показывать ли число карт в руках всех игроков
     */
    private get isPlayersCardsVisible(): boolean {
        return this.fieldState.isPlayersCardsVisible;
    }

    /**
     * Состояние игрового поля
     */
    private get fieldState(): any {
        return store.getters.getGameField;
    }

    /**
     * Количество карт игрока
     */
    private get playerCardsCount() {
        return this.fieldState.players[this.playerId]?.cardsCount ?? null;
    }
}
